import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import type { Faq } from '../../types/content';
interface FaqItemProps {
  faq: Faq;
  index: number;
  open: boolean;
  onToggle: () => void;
}
export function FaqItem({
  faq,
  index,
  open,
  onToggle
}: FaqItemProps) {
  const panelId = `faq-panel-${index}`;
  const buttonId = `faq-button-${index}`;
  return <div className="w-full" data-id="element-74" data-mp="215qrk789bifz">
      <h3 data-id="element-75" data-mp="1x2ay1jrhhy7i">
        <button id={buttonId} type="button" aria-expanded={open} aria-controls={panelId} onClick={onToggle} className="group flex items-center gap-5 py-4 text-left" data-id="element-76" data-mp="1x213rjzep4w0">
          <span className="text-[1.25rem] font-normal leading-[1.4] tracking-[0.78px] text-black sm:text-[2rem]" data-id="element-77" data-mp="1nc99yrz4sfsl">{faq.question}</span>
          <span className="relative flex h-6 w-6 flex-none items-center justify-center overflow-hidden rounded-full bg-navy/5" data-id="element-78" data-mp="1ddsbzb1rz0x1">
            <span className="absolute inset-0 rounded-full bg-black opacity-0 transition-opacity duration-300 ease-out group-hover:opacity-100" data-id="element-79" data-mp="19byjvr5nb58h" />
            <svg viewBox="0 0 24 24" aria-hidden="true" className={`relative z-10 h-[1.125rem] w-[1.125rem] flex-none text-black transition-[transform,color] duration-300 ease-out group-hover:text-white ${open ? 'rotate-180' : ''}`} data-id="element-80" data-mp="2dt0ds61xmtz9">
              <path fill="currentColor" d="M8.12 9.29L12 13.17l3.88-3.88a.996.996 0 1 1 1.41 1.41l-4.59 4.59a.996.996 0 0 1-1.41 0L6.7 10.7a.996.996 0 0 1 0-1.41c.39-.38 1.03-.39 1.42 0z" data-id="element-81" data-mp="2wlkyv1be3usi" />
            </svg>
          </span>
        </button>
      </h3>
      <AnimatePresence initial={false} data-id="element-82" data-mp="2rmhttgvetokj">
        {open && <motion.div id={panelId} role="region" aria-labelledby={buttonId} initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="overflow-hidden" data-id="element-83" data-mp="2rkx0tvoqudos">
            <div className="max-w-[48rem] pb-10 pt-5 text-[1.25rem] leading-[1.5] tracking-[0.01em] text-black" data-id="element-84" data-mp="3dvygzcizai3y">
              <p className="mb-[1.5em]" data-id="element-85" data-mp="392m1brwa1lnc">{faq.answer.intro}</p>
              {faq.answer.steps.map((step, i) => <p key={step.title} className="mb-[1.5em] last:mb-0" data-id="element-86" data-mp="344u20ctayx94" data-mpi={i}>
                  {i + 1}. {step.title}:
                  <br data-id="element-87" data-mp="3015rpmdadnk6" />
                  {step.body}
                </p>)}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}